import { useFormik } from "formik";
import React, { useMemo, useState } from "react";
import Select from "react-select";
import * as Yup from "yup";
import { ReRegistrationRemindMeLater } from "../../services/ReRegistrationService";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ArticulationAvatar from "../Articulation/ArticulationAvatar";
import { setReRegistrationsReload } from "../../store/actions";
import VideoPopup from "../video-popup/VideoPopup";
import { useBrandVideo } from "../../hooks/useBrandVideo";
import Button from "../ui/Button";
import ButtonGroup from "../ui/ButtonGroup";
import { ContainerWrapper } from "../common/GlobalElements/Wrappers";
import {
  BaseText,
  ErrorMessage,
  Heading2,
  XLargeText,
} from "../common/GlobalElements/Typography";
import { tokens } from "../../public/tokens";
import { StandardButton } from "../common/GlobalElements/StandardButton";

function ReRegLaunchForm({ data, reasonDropdownData, update, setUpdate }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isRemindMeLoading, setIsRemindMeLoading] = useState(false);
  const reload = useSelector((state) => state.registrations.reload);
  const user = useSelector((state) => state.user);

  const initialValue = {
    reReg: true,
    reasonType: "",
    reason: "",
  };

  const {
    isOpen,
    openVideo,
    closeVideo,
    iframeUrl,
    fallbackVideoUrl,
    hasVideo,
  } = useBrandVideo();

  const ReRegLaunchSchema = Yup.object({
    reReg: Yup.boolean().required("Please check Yes/No"),
    reasonType: Yup.string().when("reReg", {
      is: false,
      then: Yup.string().required("Please select any reason type"),
    }),
    reason: Yup.string().when(["reReg", "reasonType"], {
      is: (reReg, reasonType) => {
        return reReg === false && (reasonType === "8" || reasonType === "4");
      },
      then: Yup.string().required("Reason is required"),
    }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValue,
    validationSchema: ReRegLaunchSchema,
    onSubmit: (values) => {
      setIsLoading(true);
      if (values.reReg === true) {
        console.log(user);
        if (user.status == "Results Witheld") {
          history.push("/ResultWithheld");
        } else {
          history.push(
            `/reregistrationSchool/${data?.id}/${data?.qualification_higher_enrolled ? data?.qualification_higher_enrolled : data.qualification_ids || 0}`,
          );
        }
        setIsLoading(false);
      } else {
        const params = {
          rereg_course_id: data.id,
          intake_year: data.intake_year,
          intake_number: data.intake_number,
          academy_type: data.academy_type,
          remind: 0,
          submit_reason: 1,
          not_submit_reason: values.reasonType,
          not_submit_reason_description: values.reason,
          rereg_id: data.reregistration_id,
        };
        ReRegistrationRemindMeLater(params)
          .then((res) => {
            formik.resetForm();
            setIsLoading(false);
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Re-Registration reason set successfully",
            }).then((result) => {
              if (result.isConfirmed) {
                dispatch(setReRegistrationsReload(!reload));
              }
            });
          })
          .catch((error) => {
            console.error(error);
            setIsLoading(false);
          });
      }
    },
  });

  const handleRemindMeLater = () => {
    setIsRemindMeLoading(true);
    let params = {
      rereg_course_id: data.id,
      intake_year: data.intake_year,
      intake_number: data.intake_number,
      academy_type: data.academy_type,
      remind: 1,
      submit_reason: 0,
    };
    if (data?.reregistration_id) {
      params = { ...params, rereg_id: data.reregistration_id };
    }
    ReRegistrationRemindMeLater(params)
      .then((res) => {
        formik.resetForm();
        setIsRemindMeLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Remind me later set successfully",
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(setReRegistrationsReload(!reload));
          }
        });
      })
      .catch((error) => {
        console.error(error);
        setIsRemindMeLoading(false);
      });
  };

  const { handleBlur, handleSubmit, values, errors, touched, setFieldValue } =
    formik;

  return (
    <>
      <div className="launch__form">
        <ContainerWrapper className="card card-profile-info-card mb-4">
          <div className="card-body re-reg-card">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-4">
                <figure>
                  <ArticulationAvatar />
                </figure>
              </div>
              <div className="col-md-6">
                <form
                  className="d-flex flex-column"
                  noValidate
                  onSubmit={handleSubmit}
                >
                  <Heading2>
                    Your{" "}
                    <span
                      style={{
                        color: tokens.colors.theme["topbar-color"],
                        fontWeight: tokens.typography.fontWeights.bold,
                      }}
                    >
                      marks
                    </span>{" "}
                    are out and the{" "}
                    <span
                      style={{
                        color: tokens.colors.theme["topbar-color"],
                        fontWeight: tokens.typography.fontWeights.bold,
                      }}
                    >
                      portal
                    </span>{" "}
                    is open!
                  </Heading2>
                  <XLargeText as="div">
                    <p>
                      Your re-registration/articulation options are now
                      available.
                    </p>
                    <p>
                      View your options now?
                      <br />
                    </p>
                  </XLargeText>
                  <span className="d-flex align-items-center">
                    <input
                      id={"reReg1" + data.id}
                      type="radio"
                      name="reReg"
                      checked={formik.values.reReg}
                      onChange={(e) => setFieldValue(`reReg`, true)}
                    />
                    <BaseText
                      as="label"
                      htmlFor={"reReg1" + data.id}
                      className="ml-2 mb-0"
                    >
                      Yes, I'm committed to my journey
                    </BaseText>
                  </span>
                  <span className="d-flex align-items-center">
                    <input
                      id={"reReg2" + data.id}
                      type="radio"
                      name="reReg"
                      checked={!formik.values.reReg}
                      onChange={(e) => setFieldValue(`reReg`, false)}
                    />
                    <BaseText
                      as="label"
                      htmlFor={"reReg2" + data.id}
                      className="ml-2 mb-0"
                    >
                      No, I don't want to continue my studies
                    </BaseText>
                  </span>
                  {values.reReg === false && (
                    <div className="form-icon-group mb-2">
                      <Select
                        className={
                          "form-control custom-select-box" +
                          (errors.reasonType && touched.reasonType
                            ? " is-invalid"
                            : "")
                        }
                        name="reasonType"
                        value={reasonDropdownData.find(
                          (item) => item.value === values.reasonType,
                        )}
                        onChange={(option) => {
                          setFieldValue(
                            "reasonType",
                            option ? option.value : "",
                          );
                        }}
                        onBlur={handleBlur}
                        maxMenuHeight={175}
                        placeholder="Select"
                        options={reasonDropdownData}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {(values.reasonType === "8" || values.reasonType === "4") &&
                    values.reReg === false && (
                      <div className="form-group-blk mb-2">
                        <label>
                          {values.reasonType === "8"
                            ? "Reason *"
                            : "What are you looking to study *"}
                        </label>
                        <textarea
                          rows="2"
                          name="reason"
                          value={values.reason}
                          onChange={(e) =>
                            setFieldValue("reason", e.target.value)
                          }
                          className={
                            "form-control" +
                            (errors.reason && touched.reason
                              ? " is-invalid"
                              : "")
                          }
                          placeholder={
                            values.reasonType === "8"
                              ? "Explain your other reason why you chose not to re-register."
                              : "Explain what it is you are looking to study."
                          }
                        ></textarea>
                      </div>
                    )}
                  {/* display form errors */}
                  {Object.keys(errors).length && Object.keys(touched).length
                    ? Object.keys(errors).map((item) => {
                        return (
                          <ErrorMessage
                            fontSize={tokens.typography.fontSize["lg-14px"]}
                            className="mt-1 mb-0"
                            key={item}
                          >
                            {errors[item]}
                          </ErrorMessage>
                        );
                      })
                    : ""}
                  <ButtonGroup className="show-shadow">
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <i className="fas fa-cog fa-spin" />
                      ) : (
                        <i className="fal fa-check" />
                      )}
                      Submit
                    </Button>

                    {data?.late_reg == 0 &&
                      (!data?.hard_launch_date ||
                        moment.unix(data?.hard_launch_date).format("YY-MM-DD") >
                          moment().format("YY-MM-DD")) && (
                        <Button
                          type="button"
                          variant="dark"
                          onClick={handleRemindMeLater}
                          disabled={isRemindMeLoading}
                        >
                          {isRemindMeLoading ? (
                            <i className="fas fa-cog fa-spin" />
                          ) : (
                            <i className="fal fa-bell-slash" />
                          )}
                          Remind Me Later
                        </Button>
                      )}

                    {Number(data?.PMCId) > 0 && hasVideo && (
                      <Button type="button" variant="white" onClick={openVideo}>
                        <i className="fal fa-play" />
                        Watch Video
                      </Button>
                    )}
                  </ButtonGroup>
                </form>
              </div>
            </div>
          </div>
        </ContainerWrapper>
      </div>
      {isOpen && (
        <VideoPopup
          open={isOpen}
          onOpenChange={closeVideo}
          iframe={iframeUrl}
          videoUrl={fallbackVideoUrl}
        />
      )}
    </>
  );
}

export default ReRegLaunchForm;
